var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingcentral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.601 2.38C23.3688 2.38 25.62 4.6312 25.62 7.399V20.6024C25.62 23.3702 23.3688 25.6214 20.601 25.6214H7.399C4.6312 25.6214 2.38 23.3702 2.38 20.6024V7.399C2.38 4.6312 4.6312 2.38 7.399 2.38H20.6024M20.6024 0H7.399C3.3124 0 0 3.3124 0 7.399V20.6024C0 24.689 3.3124 28.0014 7.399 28.0014H20.6024C24.689 28.0014 28.0014 24.689 28.0014 20.6024V7.399C28.0014 3.3124 24.689 0 20.6024 0Z",
    fill: "#EF791A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4673 21.9804C17.2083 21.979 16.9661 21.853 16.8163 21.6416L14.9431 19.0054C14.1731 17.8014 14.0009 17.233 14.0009 15.9576V14.1614C14.0009 14.0718 14.0737 14.0004 14.1619 14.0004H17.6367C17.8089 14.0004 17.9489 13.8604 17.9489 13.6882L17.9433 9.84523H10.1271C10.0347 9.84523 9.95906 9.92083 9.95906 10.0132V21.5604C9.95906 21.8054 9.76026 22.0028 9.51666 22.0028H6.48146C6.23646 22.0028 6.03906 21.804 6.03906 21.5604V8.39343C6.03906 7.02983 7.14506 5.92383 8.50866 5.92383H19.3909C20.7503 5.92383 21.8577 7.02983 21.8605 8.38923L21.8689 14.3056C21.8689 15.266 21.3467 16.1452 20.5011 16.6016L20.3751 16.6632L18.7777 17.3828C18.6153 17.4556 18.5551 17.6544 18.6489 17.8056L20.9631 21.5366C21.0891 21.7382 20.9421 22 20.7041 21.9986L17.4659 21.9804H17.4673Z",
    fill: "#0584BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingcentral);
export default __webpack_public_path__ + "static/media/ringcentral.b053964006e25501ca59dcf3c211ee2e.svg";
export { ForwardRef as ReactComponent };